import { io } from 'socket.io-client';

class SocketService {
    constructor() {
        this.socket = null;
        this.listeners = {};
    }

    connect(token, baseUrl) {
        if (this.socket?.connected) {
            console.log('⚠️ Socket already connected');
            return this.socket;
        }

        const socketUrl = process.env.REACT_APP_TOKEN_URL || 'http://localhost:5000';

        this.socket = io(socketUrl, {
            auth: {
                "token": token,
                // "Authorization": `Bearer ${token}`,
            },
            extraHeaders: {
                'x-auth-token': token,
                'Authorization': `Bearer ${token}`,
            },
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5,
            timeout: 10000
        });

        // Connection success
        this.socket.on('connect', () => {
            console.log('✅ Socket connected:', this.socket.id);
        });

        // Join success
        this.socket.on('join-success', (data) => {
            console.log('✅ Join success:', data);
            this.emitEvent('join-success', data);
        });

        // Join error
        this.socket.on('join-error', (data) => {
            console.error('❌ Join error:', data);
            this.emitEvent('join-error', data);
        });

        // Connection error
        this.socket.on('connect_error', (error) => {
            console.error('❌ Socket connection error:', error);
            this.emitEvent('connect_error', error);
        });

        // Disconnection
        this.socket.on('disconnect', (reason) => {
            console.log('🔌 Socket disconnected:', reason);
            this.emitEvent('disconnect', { reason });
        });

        // Reconnection
        this.socket.on('reconnect', (attemptNumber) => {
            console.log('🔄 Socket reconnected after', attemptNumber, 'attempts');
            this.emitEvent('reconnect', { attemptNumber });
        });

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            console.log('🔌 Socket disconnected manually');
        }
    }

    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);

        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    off(event, callback) {
        if (this.socket && callback) {
            this.socket.off(event, callback);
        }
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
        }
    }

    emit(event, data) {
        if (this.socket?.connected) {
            this.socket.emit(event, data);
        } else {
            console.warn('⚠️ Socket not connected, cannot emit:', event);
        }
    }

    emitEvent(event, data) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => callback(data));
        }
    }

    isConnected() {
        return this.socket?.connected || false;
    }

    getSocket() {
        return this.socket;
    }
}

// Export singleton instance
const socketService = new SocketService();
export default socketService;
